// extracted by mini-css-extract-plugin
export default {"container":"NoAccountPopup_container__9OQri","icon":"NoAccountPopup_icon__HySNR","text":"NoAccountPopup_text__v4qi3"};